import React from "react";
import { cleanJoin } from "../../utils/stringUtil";

function Line({ className, height = 2, children, color }) {
  return (
    <div style={{ height: height }} className={cleanJoin(`has-background-${color}`, className)}>
      {children}
    </div>
  );
}

export default Line;
